"use client";

import { TopShopEducationTooltip } from "@faire/retailer-visitor-shared/components/TopShop/TopShopTooltip";
import { ActiveTrophy } from "@faire/web/slate/icons/Trophy";
import { Spacer } from "@faire/web/slate/spacing";
import { ResponsiveProp } from "@faire/web/slate/Theme/ResponsiveProp";
import { Typography, TypographyVariants } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { ComponentProps } from "react";

interface IProps {
  tooltipPosition?: ComponentProps<typeof TopShopEducationTooltip>["position"];
  iconSize?: string;
  typographyVariant?: ResponsiveProp<TypographyVariants>;
}

export const TopShopBadge: React.FC<IProps> = ({
  tooltipPosition,
  iconSize = "18px",
  typographyVariant,
}) => {
  const { isMobile } = useViewport();
  return (
    <TopShopEducationTooltip
      hidden={isMobile}
      position={tooltipPosition}
      icon={
        <>
          <ActiveTrophy fontSize={iconSize} titleAccess="" />
          <Spacer width={4} />
          <Typography variant={typographyVariant}>
            <StrictLocalMsg
              id="S/Y52l"
              defaultMessage="Top Shop"
              description={{
                text: "Field on the Brand Header that shows that the brand is a top shop brand",
                img: "https://cdn.faire.com/fastly/33e4cae0f9b00284c00179bdea656cdce0a74ad8f29327e00a70d91fc67946b1.png",
              }}
            />
          </Typography>
        </>
      }
    />
  );
};
